import React from "react";
import Home from "./pages/Home";
import Capability from "./pages/Capability";
import Legal from "./pages/Legal";
import capabilities from "./data/capabilities.json";
import legal from "./data/legal.json";

// Every route the site prerenders. index.js (client) and prerender.js (build)
// both resolve the current path through getRoute() so hydration markup matches.
export const CAPABILITY_SLUGS = capabilities.map((c) => c.slug);
export const LEGAL_SLUGS = Object.keys(legal); // ["privacy", "cookies"]

export const ROUTE_PATHS = [
  "/",
  ...CAPABILITY_SLUGS.map((s) => `/capabilities/${s}`),
  ...LEGAL_SLUGS.map((s) => `/${s}`),
];

export function getRoute(pathname) {
  const clean = (pathname || "/").replace(/\/+$/, "") || "/";

  const cap = clean.match(/^\/capabilities\/([a-z0-9-]+)$/);
  if (cap) {
    const match = capabilities.find((c) => c.slug === cap[1]);
    if (match) return <Capability cap={match} />;
  }

  const leg = clean.match(/^\/([a-z]+)$/);
  if (leg && legal[leg[1]]) {
    return <Legal doc={legal[leg[1]]} />;
  }

  return <Home />;
}
